import { useNumberFormatter } from "react-aria";

/**
 * Format a number as a percentage.
 *
 * @param value The number (range 0-100).
 */
export function Percent({ value, ...props }: { value: number } & Intl.NumberFormatOptions) {
    const f = useNumberFormatter({ style: "percent", maximumFractionDigits: 2, ...props });
    return f.format(value / 100);
}
